import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, testid }) => (
  <div className="flex items-center gap-3" data-testid={testid}>
    <span className="h-px w-8 bg-gold" />
    <span className="text-xs md:text-sm font-body font-semibold tracking-[0.3em] uppercase text-gold">
      {children}
    </span>
  </div>
);
